import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { IMAGES, WHATSAPP, BIZ } from "../data";
import { WaIcon } from "../components/Cta";

const LINKS = [
  { label: "Sobre", href: "#sobre" },
  { label: "Método", href: "#metodo" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Localização", href: "#localizacao" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-[9000] transition-colors duration-300 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-[--gold]/15"
          : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={IMAGES.logo} alt="+5 Studio Training" className="h-11 w-auto" />
          <span className="hidden font-display text-lg font-bold uppercase tracking-wide text-white sm:block">
            {BIZ.name}
          </span>
        </a>

        <div className="hidden items-center gap-9 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-display text-sm font-semibold uppercase tracking-widest text-neutral-300 transition-colors duration-300 hover:text-[--gold]"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href={BIZ.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hidden text-neutral-300 transition-colors duration-300 hover:text-[--gold] sm:block"
            data-testid="nav-instagram"
          >
            <Instagram className="h-5 w-5" />
          </a>
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="inline-flex items-center gap-2 rounded-none bg-[--gold] px-4 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-black transition-colors duration-300 hover:bg-[--gold-soft]"
          >
            <WaIcon className="h-4 w-4" />
            <span className="hidden sm:inline">Agende</span>
          </a>
        </div>
      </nav>
    </motion.header>
  );
}
